module.exports = __webpack_public_path__ + "img/header-memoireRingsSignature.4c96c70.webp";